/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_First_Task_QuestionInputs */

const en_faq_first_task_question = /** @type {(inputs: Faq_First_Task_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What’s a good first thing to bring?`)
};

const lv_faq_first_task_question = /** @type {(inputs: Faq_First_Task_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ar ko labi sākt?`)
};

/**
* | output |
* | --- |
* | "What’s a good first thing to bring?" |
*
* @param {Faq_First_Task_QuestionInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_first_task_question = /** @type {((inputs?: Faq_First_Task_QuestionInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_First_Task_QuestionInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_first_task_question(inputs)
	return en_faq_first_task_question(inputs)
});